import { type Filter, FilterType, type TreeFilter } from '../types/filters';

export function patchTreeFilterNames(
  filter: TreeFilter,
  nameMap: Map<string, string>
): TreeFilter;
export function patchTreeFilterNames(
  filter: Filter,
  nameMap: Map<string, string>
): Filter;
export function patchTreeFilterNames(
  filter: Filter,
  nameMap: Map<string, string>
): Filter {
  if (filter.type !== FilterType.TREE || !('selections' in filter)) {
    return filter;
  }

  const patchName = <T extends { id: string; name: string }>(sel: T): T => {
    const resolved = nameMap.get(sel.id);
    return resolved ? { ...sel, name: resolved } : sel;
  };

  const patchedSelections = filter.selections.map(patchName);

  const patchedPrimarySelections =
    'primarySelections' in filter && Array.isArray(filter.primarySelections)
      ? filter.primarySelections.map(patchName)
      : undefined;

  return {
    ...filter,
    selections: patchedSelections,
    ...(patchedPrimarySelections !== undefined && {
      primarySelections: patchedPrimarySelections,
    }),
  };
}
